import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsuarioContratistaService {
  private apiUrl = `${environment.apiUrl}/api/usuario-contratista`;

  constructor(private http: HttpClient) {}

  getContratistaPorUsuario(userId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/usuario/${userId}`, { withCredentials: true }).pipe(
      catchError(error => {
        console.error('Error al obtener contratista por usuario:', error);
        return throwError(() => error);
      })
    );
  }

  asignarContratistas(usuarioId: number, nits: string[]): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}`, { usuarioId, nits }, { withCredentials: true }).pipe(
      catchError(error => {
        console.error('Error al asignar contratistas:', error);
        return throwError(() => error);
      })
    );
  }
}
